import { Box, Button, Container, Paper, Modal, Typography,TextField } from '@mui/material'
import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import * as yup from 'yup'
import { addCategory, updateCategory, updateLastActive } from '../../utils/templatesApi'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { getSingleCategory } from '../../utils/templatesApi'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
}

const CreateCategory = ({ setRefresh,open,handleOpen,handleClose,userId }) => {
  const [category, setCategory] = React.useState()
  const navigate = useNavigate()
  const { id } = useParams()

  const categoryData = async () => {
    try {
      const response = await getSingleCategory(id)
      setCategory(response.data)
    } catch (error) {
      console.error('Error fetching category data:', error)
    }
  }

  useEffect(() => {
    if (id) {
      categoryData()
    } else {
      setCategory(null)
    }
  }, [id])

  const validationSchema = yup.object({
    category_name: yup.string().required('Category Name is required'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category_name: category ? category.category_name : '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
       updateLastActive(userId, new Date())
      if (id) {
        const response = await updateCategory(values, id)
        if (response.success) {
          setRefresh(prev => !prev)
          toast.success('Category Updated Successfully')
          navigate('/categories')
          handleClose()
        }
      } else {
        const response = await addCategory(values)
        if (response.success) {
          setRefresh(prev => !prev)
          toast.success('Category Created Successfully')
          resetForm()
          handleClose()
        }
      }
    },
  })


  return (
    <Container maxWidth='lg' sx={{ minWidth: '80vw' }}>
      <Button
        type='submit'
        variant='contained'
        sx={{
          textTransform: 'capitalize',
          height: '50px',
          width: '120px',
          fontSize: '16px',
          display: 'flex',
          justifySelf: 'end',
          mt: 4,
          backgroundColor: '#111827',
        }}
        onClick={handleOpen}
      >
        Create
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Paper elevation={3} sx={style} >
          <Typography variant='h4' fontWeight={550}>{id?"Update":"Create"} Category</Typography>
          <Box
            component={'form'}
            onSubmit={formik.handleSubmit}
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <TextField
              name='category_name'
              label='Category'
              margin='normal'
              fullWidth
              sx={{ height: '55px' }}
              value={formik.values.category_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.category_name && formik.errors.category_name
              }
              error={
                formik.touched.category_name &&
                Boolean(formik.errors.category_name)
              }
            />
            <Button
              type='submit'
              variant='contained'
              sx={{
                textTransform: 'capitalize',
                height: '55px',
                width: '130px',
                fontSize: '16px',
                backgroundColor: '#111827',
              }}
            >
              {' '}
              {id ? 'Update' : 'Create'}
            </Button>
          </Box>
        </Paper>
      </Modal>
    </Container>
  )
}

export default CreateCategory
